/* Shopify's rendered locale and localization form are the only language authority. */
(() => {
  'use strict';
  const node = document.getElementById('r24-i18n');
  let data = { strings: {}, pairs: {} };
  try { if (node) data = JSON.parse(node.textContent); } catch (_) {}
  const locale = document.documentElement.lang || 'en';
  const fill = (value, params) => String(value).replace(/\{\{\s*(\w+)\s*\}\}|__R24_(\w+)__/g, (token, brace, marker) => Object.prototype.hasOwnProperty.call(params, brace || marker) ? String(params[brace || marker]) : token);
  const t = (key, params = {}, fallback = '') => fill(data.strings[key] ?? fallback, params);
  const pair = (de, en) => data.pairs[en] ? t(data.pairs[en], {}, en) : locale.toLowerCase().startsWith('de') ? de : en;
  window.VenluI18n = Object.freeze({ locale, t, pair });
  try { localStorage.removeItem('venlu-ui-language'); } catch (_) {}
  function init(scope = document) {
    const roots = [...scope.querySelectorAll('[data-root]')];
    if (scope.matches?.('[data-root]')) roots.push(scope);
    roots.forEach(element => { element.dataset.root = (element.dataset.root || '/').replace(/\/?$/, '/'); });
    scope.querySelectorAll('[data-native-localization]').forEach(form => {
      if (form.dataset.ready) return;
      form.dataset.ready = 'true';
      form.addEventListener('submit', () => {
        const returnTo = form.querySelector('input[name="return_to"]');
        if (returnTo) returnTo.value = location.pathname + location.search + location.hash;
      });
      form.querySelector('select[name="language_code"]')?.addEventListener('change', () => form.requestSubmit());
    });
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
